import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { profileEndpoints } from "../services/apis";
import { apiConnector } from "../services/apiconnector";
import {
  getAllIssue,
  getAllIssueBookReport,
} from "../services/operations/bookDetais";
import TableData from "../components/common/TableData";

function DashboardMain() {
  const { GET_ALL_USERS } = profileEndpoints;
  const { token } = useSelector((state) => state.auth);

  const [allStudent, setAllStudent] = useState(0);
  const [allBook, setAllBook] = useState([]);
  const [allIsuedBook, setAllIssuedBook] = useState([]);
  const [issuedBook, setIssuedBook] = useState(true); // for the issued for to student
  const [issued, setIssued] = useState(true); // for books report all
  const [loading, setLoading] = useState(false);
  const [allBookReport, setAllBookReport] = useState(0);
  const [allIssuedBookReport, setAllIssuedBookReport] = useState(0);
  const [page, setPage] = useState(1);
  const [allpage, setAllPage] = useState(1);

  const fetchStudents = async () => {
    try {
      const response = await apiConnector(
        "GET",
        `${GET_ALL_USERS}?page=1&limit=10)`,
        null,
        {
          Authorization: `Bearer ${token}`,
        }
      );
      //   console.log(
      //     "GET_ALL_CATEGORY_API API RESPONSE............",
      //     response.data.data
      //   );

      if (!response?.data?.success) {
        throw new Error("Could Not Fetch Students");
      }
      const { data } = response.data;
      //   console.log(data.length);

      setAllStudent(data?.length);
    } catch (error) {
      console.log("GET_ALL_USERS API ERROR............", error);
      //   toast.error(error.message)
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await getAllIssue(page, 10, token);
        // console.log("course details res: ", res.data)
        setAllIssuedBookReport(res);
        // console.log(allIssuedBookReport?.data?.data?.length)
      } catch (error) {
        console.log("Could not fetch Course Details");
      }
      setLoading(false);
    })();
  }, [page]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await getAllIssueBookReport(allpage, 10, token);
        // console.log("course details res: ", res.data)
        setAllBookReport(res);
        // console.log(allBookReport?.data?.data?.length)
      } catch (error) {
        console.log("Could not fetch Course Details");
      }
      setLoading(false);
    })();
  }, [allpage]);

  return (
    <div className="min-h-[calc(100vh-5.8rem)]   pt-4 w-11/12 mx-auto pb-4">
    
    <div>
      
    </div>
    
      <div className=" mt-10">
        <div>
          <div className="w-full bg-richblack-800 p-3 flex  justify-around rounded-2xl">
            <button
              className={` lg:p-3 p-1 rounded-3xl font-mulish font-bold  lg:text-xl ${
                issued
                  ? "bg-yellow-25"
                  : "bg-richblack-100 hover:bg-richblack-300"
              }`}
              onClick={() => setIssued(true)}
            >
              Issue Book Report{" "}
            </button>
            <button
              className={`x p-3 rounded-3xl font-mulish font-bold  lg:text-xl ${
                !issued
                  ?"bg-yellow-25"
                  : "bg-richblack-100 hover:bg-richblack-300"
              }`}
              onClick={() => setIssued(false)}
            >
              All Issued Book Report{" "}
            </button>
          </div>
        </div>
      </div>

      {issued ? (
        loading ? (
          <div className="grid  place-items-center">
            <div className="spinner"></div>
          </div>
        ) : allIssuedBookReport?.data?.data?.length > 0 ? (
          <TableData
            prop={allIssuedBookReport?.data?.data}
            setPage={setPage}
            currentPage={page}
            totalPages={allIssuedBookReport?.data?.totalPages}
            student={true}
          all={true}

          />
        ) : (
          <p className="text-center pt-5 text-3xl font-mulish">
            {" "}
            No Issued Book{" "}
          </p>
        )
      ) : loading ? (
        <div> Loaing..... </div>
      ) : allBookReport?.data?.data?.length > 0 ? (
        <TableData
          prop={allBookReport?.data?.data}
          setPage={setAllPage}
          currentPage={allpage}
          totalPages={allBookReport?.data?.totalPages}
          student={true}
          all={true}
        />
      ) : (
        <p className="text-center pt-5 text-3xl font-mulish">
          {" "}
          No record{" "}
        </p>
      )}
    </div>
  );
}

export default DashboardMain;
